export enum TipoContaBancoEnum {
  ContaCorrente = 0,
  CartaoCredito = 1
}
